<template>
  <div class="header-container">
    <div class="header">
      <div class="orange-top-bar" />
      <div class="header-img-container">
        <img
          class="header-img"
          src="~@/assets/img/logo-kol.png"
          alt="Bibliociencia"
        />

        <div class="header-buttons">
          <div class="spacer"></div>
          <!-- Language Selector -->
          <div class="language-container">
            <v-select
              :items="items"
              v-model="language"
              item-text="language"
              item-value="code"
              elevate="4"
              solo
              class="lang-selector"
              dark
              dense
              hide-details
              @change="handleLanguageChange($event)"
            ></v-select>
          </div>
          <!-- Logout button -->
          <v-btn
            @click="logOut"
            elevate="4"
            small
            dark
            v-if="isLoggedIn"
            class="logout-button blue-button"
          >
            {{ $t('common.logout') }}
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { auth } from '../firebase'

export default {
  data: () => {
    return {
      language: localStorage.getItem('bd-kol-lang') || 'es',
      isLoggedIn: false
    }
  },
  methods: {
    handleLanguageChange(value) {
      localStorage.setItem('bd-kol-lang', value)
      window.location.reload()
    },
    logOut: function() {
      auth.signOut().then(() => {
        this.$router.push({ name: 'login' })
      })
    },
    goBack: function() {
      this.$router.push({ name: 'admin' })
    }
  },
  computed: {
    items() {
      return [
        {
          language: this.$t('common.es'),
          code: 'es'
        },
        {
          language: this.$t('common.pt'),
          code: 'pt'
        }
      ]
    }
  },
  created() {
    if (auth.currentUser) {
      this.isLoggedIn = true
    }
  }
}
</script>

<style lang="scss">
.header-container {
  .header {
    padding-top: 13px;
    position: sticky;
    top: 0;
    z-index: 2;
    background: white;
    height: 127px;

    @media only screen and (min-width: 600px) {
      height: 152px;
    }
    /*
  @media only screen and (min-width: 600px) {
    
  }
  @media only screen and (max-width: 599px) {
    padding-top: 10px;
    .col-12 {
      padding: 0;
    }
  }*/
    .header-img-container {
      width: 100%;
      position: absolute;
      top: 0;
      text-align: center;
      z-index: 2;

      .header-img {
        width: 100%;
        max-width: 450px;
        padding: 10px 20px;

        @media only screen and (min-width: 600px) {
          max-width: 570px;
        }
      }
    }

    .orange-top-bar {
      background-color: #d66c00;
      width: 100%;
      position: absolute;
      top: 0;
      height: 39px;
      @media only screen and (min-width: 600px) {
        height: 67px;
      }
    }
    .language-container {
      width: 135px;
      margin-right: 10px;

      .theme--dark.v-text-field--solo > .v-input__control > .v-input__slot {
        margin-bottom: 0;
        background: rgb(0 69 140 / 84%);
      }
      .v-text-field.v-text-field--solo.v-input--dense > .v-input__control {
        min-height: 28px;
      }
    }
  }
  .header-buttons {
    display: flex;
    justify-content: space-between;
    padding: 0px 40px;

    .blue-button.theme--dark.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
      background-color: rgba(0, 69, 140, 0.84);
    }
  }
}
</style>
